"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "TableBody", {
    enumerable: true,
    get: function() {
        return TableBody;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useTableBody = require("./useTableBody");
const _renderTableBody = require("./renderTableBody");
const _useTableBodyStylesstyles = require("./useTableBodyStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const TableBody = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useTableBody.useTableBody_unstable)(props, ref);
    (0, _useTableBodyStylesstyles.useTableBodyStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useTableBodyStyles_unstable')(state);
    return (0, _renderTableBody.renderTableBody_unstable)(state);
});
TableBody.displayName = 'TableBody';
